module.exports = require("ref-multiple-table/lib/index.css");